/**
 * STOP VARIANT SELECTION FROM SCROLLING TO TOP
 * Prevents annoying scroll on mobile when selecting variants
 */

(function() {
  'use strict';
  
  // Store scroll position before variant change
  let scrollPosition = 0;
  
  // Listen for variant changes
  document.addEventListener('click', function(e) {
    // Check if clicking on a variant selector
    if (e.target.matches('input[type="radio"], label[for*="option"], .product-form__input label')) {
      scrollPosition = window.scrollY;
      
      // Prevent scroll after a small delay
      setTimeout(() => {
        window.scrollTo(0, scrollPosition);
      }, 10);
    }
  }, true);
  
  // Also catch variant change events
  document.addEventListener('variant:change', function(e) {
    const currentScroll = window.scrollY;
    setTimeout(() => {
      window.scrollTo(0, currentScroll);
    }, 1);
  });
  
  // Override any scrollIntoView calls on variant change
  const originalScrollIntoView = Element.prototype.scrollIntoView;
  Element.prototype.scrollIntoView = function(...args) {
    // Check if this is being called on product-related elements
    if (this.closest && this.closest('.product__info')) {
      // Don't scroll for product info elements
      return;
    }
    // Otherwise allow normal scrolling
    return originalScrollIntoView.apply(this, args);
  };
  
})();